/** TZ-docs/08 §8.5.3 — bosilganda navigator.vibrate(20) */
export function vibrateTap(): void {
  if (typeof navigator !== 'undefined' && 'vibrate' in navigator) {
    navigator.vibrate(20);
  }
}
